import { render, staticRenderFns } from "./control-list.vue?vue&type=template&id=5e707408&scoped=true"
import script from "./control-list.vue?vue&type=script&lang=js"
export * from "./control-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e707408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e707408')) {
      api.createRecord('5e707408', component.options)
    } else {
      api.reload('5e707408', component.options)
    }
    module.hot.accept("./control-list.vue?vue&type=template&id=5e707408&scoped=true", function () {
      api.rerender('5e707408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/control-list.vue"
export default component.exports